export const GET_CATEGORY_FOR_REGISTER_WARRANTY_DATA_ENDPOINT='/Warranty/GetCategories';